<template>
  <div class="edituserinfo" v-show="userInfoShow">
    <div class="edit_mask"  v-if="userInfoShow" @click="editMaskClick">
        <div class="userInfo" @click.stop="contentClick" :class="userInfoHeight">
            <div class="top">
                <div class="title">{{title}}</div>
                <div class="close" @click.stop="maskClick">X</div>
            </div>
            <div class="content" v-if="title == '编辑资料'">
                <div class="awater" v-if=" awater != null && awater.length == 0" @click="handleUpload"></div>
                <img class="awater-icon" v-if="awater == null" src="./avatar.png" @click="handleUpload">
                <img class="awater-icon"  v-if=" awater != null && awater.length>0" :src="awater" @click="handleUpload">
                <my-upload field="img"
                    @crop-success="cropSuccess"
                    v-model="upload_show"
                    :width="300"
                    :height="300"
                    :withCredentials="withCredentials"	
                    img-format="png">
                </my-upload>

                <div class="middle">
                    <div class="name_">昵称 &nbsp &nbsp <input class="user_name" v-model="user_nickName"></div>
                    <div class="sex_" >性别 &nbsp &nbsp 
                        <el-radio-group v-model="sex" @change="handleChangeOption">
                            <div class="item"><el-radio :label="1">男</el-radio></div>
                            <div class="item"><el-radio :label="0">女</el-radio></div>
                        </el-radio-group>
                    </div>
                    <div class="birthday_" style="line-height:25px;">生日 &nbsp &nbsp 
                        <el-date-picker class="date_picker"
                            v-model="birthday"
                            type="date"
                            size="mini"
                            placeholder="选择日期"
                            :picker-options="pickerOptions"
                            value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </div>   
                </div>

                <div class="bottom">
                    <div class="personal_text">
                        <span class="name">个性签名&nbsp&nbsp</span>
                        <el-input class="text"
                            size="mini"
                            type="textarea"
                            :rows="3"
                            suffix-icon=""
                            resize="none"
                            v-model="intro">
                        </el-input>
                    </div>  
                    <el-button type="info" size="mini" class="cancel" @click="maskClick">取消</el-button>
                    <el-button type="warning" size="mini" class="confirm" @click="handleUserInfoUpdate">确定</el-button>
                </div>
            </div>

            <!-- 修改密码 -->
            <div class="content" v-if="title == '修改密码'">
                <div class="middle" style="top:24px;width:260px;height:150px;background:#fff;left:60px;">
                    <div style="height:30px;background:#fff;">
                        <div style="display:inline-block;line-height:30px;">旧密码</div>
                        <input style="margin-left:10px;border:0px;border-bottom:1px solid #c7c7c7;height:30px;width:180px;" placeholder="请输入你的原密码" type="password" v-model="oldPassword">
                        <!-- <div style="position:relative;display:inline-block;top:5px;height:14px;left:-20px;" @click="showPassword('old')">
                            <img src="./register_nosee.png" v-show="!show_password_old">
                            <img src="./register_see.png" v-show="show_password_old">
                        </div> -->
                    </div>
                    <div style="height:30px;background:#fff;margin-top:15px;">
                        <div style="display:inline-block;line-height:30px;">新密码</div>
                        <input style="margin-left:10px;border:0px;border-bottom:1px solid #c7c7c7;height:30px;width:180px;" placeholder="请输入你的新密码(至少六位)" :type="password_type_new" v-model="newPassword">
                        <div style="position:relative;display:inline-block;top:5px;height:14px;left:-20px;" @click="showPassword('new')">
                            <img src="./register_nosee.png" v-show="!show_password_new">
                            <img src="./register_see.png" v-show="show_password_new">
                        </div>
                    </div>

                    <el-button type="info" size="mini" class="cancel" style="position:absolute;left:40px;bottom:0;" @click="maskClick">取消</el-button>
                    <el-button type="warning" size="mini" class="confirm" style="position:absolute;left:140px;bottom:0;" @click="handleChangePassword">确定</el-button>
                </div>
                
            </div>
        </div>
        
    </div>  
    
  </div>
</template>

<script>

import EUY from '@/common/scripts/euy'
import myUpload from 'vue-image-crop-upload'
  export default {
    components: {
        // Psocket,
        myUpload,
    },

    data () {
      return {
            token:'',
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                }
            },
            user_nickName:'',
            sex:0,
            birthday:'1990-01-01',
            intro:'',
            // awater:'',
            upload_show:false,
            noSquare: true,
            imgDataUrl: '',
            // 七牛token
            qiniu_token:'', 
            upload_url:'http://upload.qiniup.com',
            withCredentials:true,
            upload_image_url:'',
            /*********************修改密码相关*******************/
            show_password_old:false,
            show_password_new:false,
            password_type_old:'password',
            password_type_new:'password',
            oldPassword:'',
            newPassword:'',
          
        }
    },
    computed: {
        userInfoHeight(){
            if(this.title == '编辑资料'){

            }else if(this.title == '修改密码'){
                return 'height230'
            }
        },

    },

    props:['userInfoShow','title','user_icon',],
    methods: {
      editMaskClick(){

      },

      maskClick(){
          this.$emit('showUserInfo',false)
          this.reset()
      },
      contentClick(){

      },
      handleChangeOption(val){

      },
      
      // 修改用户信息的方法
      handleUserInfoUpdate(){
        let URL = process.env.HOST + '/passport/changeProfile'
        let params = 'tokenId=' + this.token + '&baseInfo[nickname]=' + this.user_nickName + '&extendInfo[sex]=' + this.sex + '&extendInfo[birthday]=' + this.birthday + '&extendInfo[intro]=' + this.intro 
        
        if(this.upload_image_url.length > 0){
            // 用户上传了头像
            let qiniu_result = {
                'image-type':'PNG',
                'image-frames':1,
                'image-height':300,
                'image-width':300,
                'url':this.upload_image_url,
                'time':0,
                'message':'ok',
                'minetype':'image/jpeg',
                'sign':'',
                'code':200,
                'file_size':0,
            }
            let temp = '&avatarInfo[policy]=' + '' + '&avatarInfo[sign]=' + '' + '&avatarInfo[_result]=' + JSON.stringify(qiniu_result) + '&avatarInfo[_name]=qiniu-cdn-passport-dev' + '&avatarInfo[_provider]=qiniu' + '&avatarInfo[action]=qiniu-upload'
            params = params + temp

        }

        let headers = {
            'token': this.token,
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        }  
        console.log('修改用户信息的参数--------- param ' + JSON.stringify(params))
        this.AJAX.post(URL, headers, params).then((data)=>{
            console.log('edit userInfo --------- success ' + JSON.stringify(data))
            if(data.code == '0'){
                this.maskClick()
                this.reset()
                let user_icon = data.result.avatarInfo.middle
                // 修改首页的用户头像
                this.$emit('changeHomePageUserIcon',user_icon)
                console.log('edit userInfo --------- icon  ' + user_icon)
                this.$message({
                    message: '修改成功',
                    type: 'success'
                })
            }
        }).catch((err)=>{
            console.log('edit userInfo --------- error  ' + JSON.stringify(err))
            this.$message({
                message: err.msg||err.message,
                type: 'error'
            })
        })
      },
    
      handleUpload(){
          this.upload_show = !this.upload_show
      },

    cropSuccess(imgDataUrl, field){
        // console.log('-------- crop success haha --------');
        this.awater = imgDataUrl
        let URL = process.env.HOST + '/pro/api/ExtraStorage/qiniuToken'
        let params = {
            'bucket_type':'image-passport',
            'token':this.token,
        }
        let headers = {
            'token': this.token,
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', 
        } 
        // 请求上传图片的token
        this.AJAX.get(URL, headers, params).then((data)=>{
            // console.log('请求七牛token ===== 1  ' + JSON.stringify(data))

            if(data.code == '0'){
                // console.log('请求七牛token ===== 1  ' + JSON.stringify(data))
                const formdata = new FormData()
                formdata.append('file',this.dataURLtoBlob(imgDataUrl))
                formdata.append('token',data.result.token)
                formdata.append('name','avatar')
                // 上传图片到七牛
                console.log('上传图片到七牛的参数 ------------- 0 ' + JSON.stringify(data))
                this.AJAX.post(this.upload_url, {}, formdata).then((response)=>{
                    // console.log('上传图片到七牛------------- 1 ' + JSON.stringify(response))
                    if(response.hash == response.key){
                        // console.log('上传图片到七牛-------------  ' + JSON.stringify(response))
                        this.upload_image_url = '{qiniu-image-passport}/' + response.hash
                        // console.log('上传图片到七牛------------- 3 ' + this.upload_image_url)
                    }

                    // {qiniu-image-passport}/
                }).catch((err)=>{
                    // console.log('上传图片到七牛-------------  2  ' + JSON.stringify(err))
                })
            }
        }).catch((err)=>{
            console.log('请求七牛token ===== error  ' + JSON.stringify(err))
        })
	},

      // 
      loadUserInfo(){
        let URL = process.env.HOST + '/passport/profile'
        let params = {
          'tokenId': this.token,
        }
        let headers = {
            'token': this.token,
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', 
        }  
        this.AJAX.get(URL, headers, params).then((data)=>{
            if(data.code == '0'){
                // data = {"code":0,"msg":"","result":{"tokenId":"ohka6k6f6i5qfbul7a5rk4p7c1","tokenIdTimeout":172800,"baseInfo":{"gid":"787120471182155724","regionCode":"0086","mobile":"13911937253","email":null,"nickname":"邓志琦","isPassword":true,"createdtime":"2016-12-12 08:55:44","role_type":0,"official_intro":""},"extendInfo":{"sex":"1","areacode":null,"areaname":null,"birthday":"2007-04-25","qq":null,"weixin":null,"fullname":null,"company":null,"position":null,"intro":"null"},"avatarInfo":{"tiny":null,"small":null,"middle":null,"large":null,"imgtype":"3"},"connectInfo":{"weixin":null,"qq":null,"weibo":null},"oid":"10ouza001"}}
                this.user_nickName = data.result.baseInfo.nickname
                this.sex = Number(data.result.extendInfo.sex)
                
                if(data.result.extendInfo.birthday == null){
                    //   console.log('44444')
                }else{
                      console.log('33333')
                    //   this.birthday = data.result.extendInfo.birthday
                }
                this.intro = data.result.extendInfo.intro
                if(typeof  this.intro == null || JSON.stringify(this.intro) == '{}'){
                    this.intro = ''
                }
                this.awater = data.result.avatarInfo.middle
                console.log('hhhhhh ==== ' + data.result.extendInfo.birthday)
            }
           console.log('获取用户信息 --------- success  ' + JSON.stringify(data))
        }).catch((err)=>{
            console.log('获取用户信息 --------- error  ' + JSON.stringify(err))
        })
      },

      /*********************修改密码相关*******************/
        showPassword(type){
            if(type == 'old'){
                this.show_password_old = !this.show_password_old
                this.password_type_old = this.show_password_old?"text":"password"
            }else if (type == 'new'){
                this.show_password_new = !this.show_password_new
                this.password_type_new = this.show_password_new?"text":"password"
            }
            
        },

        // 修改密码-> 确定
        handleChangePassword(){
            if(this.oldPassword.length == 0 || this.newPassword.length == 0) return
            let oldPwd_md5 = this.$md5(this.oldPassword)
            let URL = process.env.HOST + '/passport/changepwd'
            let params = 'tokenId=' + this.token + '&oldPassword=' + oldPwd_md5 + '&password=' + this.newPassword 
            let headers = {
                'token': this.token,
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', 
            }  

            this.AJAX.post(URL, headers, params).then((data)=>{
                if(data.code == '0'){
                    let login_status = {
                                        'tokenId': data.result.tokenId,
                                        'exkey': data.result.exkey,
                                        'oid': data.result.oid,
                                        }
                    EUY.SetStorage('login_status',login_status)
                    this.maskClick()
                    this.reset()
                    this.$message({
                        message: '密码修改成功',
                        type: 'success'
                    })
                }
            }).catch((err)=>{
                this.$message({
                        message: '密码修改失败',
                        type: 'error'
                 })
            })
        },

        // base64转二进制
        dataURLtoBlob(dataurl) {    
            var arr = dataurl.split(','),    
            mime = arr[0].match(/:(.*?);/)[1],    
            bstr = atob(arr[1]),    
            n = bstr.length,   
            u8arr = new Uint8Array(n);    
            while (n--) {        
                u8arr[n] = bstr.charCodeAt(n);    
                }    
                return new Blob([u8arr], {       
                        type: mime    
                });
        },

        reset(){
            // this.user_nickName = ''  
            // this.sex = ''
            // this.birthday = ''
            // this.intro = ''
            this.upload_image_url = ''
            // 修改密码相关  
            this.oldPassword = ''
            this.newPassword = ''
            this.password_type_old = 'password'
            this.password_type_new = 'password'
            this.show_password_old = false
            this.show_password_new = false
            // this.awater = ''

        },
    },
    mounted () {
        this.token = EUY.GetStorage('login_status').tokenId
        console.log('bbbbbbbbbbbbbbbbbbc')
        this.loadUserInfo()
    },

    watch: {
            'title': function(){
                // console.log('------------ title ')
                // this.loadUserInfo()
            },

            'user_icon':function(){
                this.awater = this.user_icon
                // console.log('------------ user_icon ')
            },
        },
  }
</script>

<style lang="stylus">
  .edit_mask
    position:absolute
    left:0
    top:0  
    width:100%
    height:100%
    cursor:pointer
    background:rgba(255,255,255,0.4) 
    z-index:10
  .userInfo
    position:fixed
    width:380px
    height:435px
    top:0
    right:0
    bottom:0
    left:0
    margin:auto
    z-index:100 
    background:#fff
    // border:1px solid #c5c5c5
    box-shadow: 0 1px 3px rgba(0,0,0,.4)
    .top
      width:100%
      height:35px
      left:0
      top:0 
      .title
        width:100%
        height:35px
        left:0
        top:0
        text-align:center
        font-size:16px
        line-height:35px
        color:#2f2f2f
        display:inline-block  
        background:#e8e8e8 
      .close
        position:absolute
        display:inline-block 
        float:right 
        right:0
        top:0
        height:35px
        width:35px
        text-align:center
        font-size:16px
        line-height:35px 
    .content
        position:absolute  
        left:0
        top:35px
        bottom:0
        right:0
        // background:blue
        .awater 
            position:absolute
            width:60px
            height:60px
            top:24px 
            right:0
            bottom:0
            left:160px
            border-radius:60px
            background:#fff  
        .awater-icon 
            position:absolute
            width:60px
            height:60px
            top:24px 
            right:0
            bottom:0
            left:160px
            border-radius:60px
            background:#fff   
        .middle
            position:absolute
            top:120px
            left:70px
            width:240px
            height:115px
            margin:auto   
            // background:yellow
            .name_
                position:absolute
                top:10px
                left:0
                right:0
                height:25px
                // background:green 
                .user_name
                    width:180px
                    height:25px
                    border:0px
                    border-bottom:1px solid #d2d2d2
            .sex_
                position:absolute
                top:45px
                left:0
                right:0
                height:25px
                // background:red 
              .item  
                display:inline-block 
                margin-right:30px
                margin-top:5px
                height:25px  
            .birthday_
                position:absolute
                top:80px
                left:0
                right:0
                height:25px
                // background:red 
                .date_picker
                  position:absolute
                  top:0         
                  width:195px
                  height:25px
        .bottom
            position:absolute
            top:240px
            left:50px
            width:280px
            // height:115px
            bottom :32px
            margin:auto 
            line-height:25px 
            // background:yellow 
            .name
                display:inline-block
            .text
                top:0
                height:25px
                width:195px
            .cancel
                position:absolute
                width : 85px
                height: 30px
                margin-left: 15px 
                bottom:0px 
            .confirm  
                position:absolute
                width : 85px
                height: 30px
                margin-left: 160px 
                bottom:0px    
  .height230
     height:230px
     background:#fff       
</style>



// WEBPACK FOOTER //
// EditUserInfo.vue?48147a94